import { render } from "./EventviewSidebar.vue?vue&type=template&id=d984ae5a"
import script from "./EventviewSidebar.vue?vue&type=script&lang=js"
export * from "./EventviewSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__